import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { AiOutlineDelete } from 'react-icons/ai';
import { AiOutlineFileAdd, AiOutlineUsergroupAdd } from "react-icons/ai";
import { FiImage, FiUser, FiCamera } from 'react-icons/fi';
import { AiOutlineFile, AiOutlineUser, AiOutlineTeam, AiOutlineVideoCamera, AiOutlineArrowLeft } from 'react-icons/ai';
import { FaChevronDown, FaChevronRight, FaCog, FaBell, FaLink, FaUser, FaImage, FaShieldAlt, FaLock, FaSignOutAlt, FaUserLock, FaTimes, FaBars } from 'react-icons/fa';
import RightSideFriend from '../../Components/FindfriendPage/RightSideFriend';
import MyPost from '../../Components/ProfilePage/MyPost';
import ProfileEdit from '../../Components/DropDown/ProfileEdit';
import { useDispatch, useSelector } from 'react-redux';
import {
  getUserSettings, send2faCode, verify2faAction, toggleTwoFA, updateSocialMedia, toggleOnlineStatusVisibility,
  getTwoFADetails, setupAuthenticator, verifyAuthenticator, disableAuthenticator,
} from '../../redux/setting/settingsAction';
import { FaCopy, FaDownload } from 'react-icons/fa';
import moment from 'moment';
import { deleteAccount, updatePassword, uploadCoverPhoto, uploadProfilePics } from '../../redux/user/userAction';
import { toast } from 'react-toastify';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { IoArrowBackOutline } from 'react-icons/io5';
import Privacy from "../../images/privacy.png"

const ProfileSection = ({ title, items }) => (
  <div className="space-y-4">
    <h4 className="text-sm font-semibold text-gray-300 tracking-wide border-l-4 border-[#BE9524] pl-2">
      {title}
    </h4>

    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="
            flex flex-col sm:flex-row 
            justify-between sm:items-center 
            gap-3 sm:gap-0
            py-3 px-2
            bg-customDark/40 
            rounded-lg 
            border border-gray-800
          "
        >
          {/* Left side (label + value) */}
          <div>
            <div className="text-sm text-gray-400">{item.label}</div>
            <div className="mt-1 text-gray-200 text-sm break-words">
              {item.value}
            </div>
          </div>

          {/* Right side (icons + edit button) */}
          <div className="flex items-center space-x-4 self-end sm:self-auto">
            {item.icon && (
              <FontAwesomeIcon
                icon={item.icon}
                onClick={item.onToggle}
                className="cursor-pointer text-gray-500 hover:text-[#BE9524] transition"
              />
            )}

            {item.showEdit !== false && (
              <button
                onClick={item.onEdit}
                className="
                  text-sm 
                  text-customGold 
                  hover:text-customGray 
                  font-medium
                "
              >
                Edit
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);


// const languages = [
//   { value: 'en', label: 'English' },
//   { value: 'ha', label: 'Hausa' },
//   { value: 'yo', label: 'Yoruba' },
//   { value: 'ig', label: 'Igbo' },
//   { value: 'fu', label: 'Fula' },
//   { value: 'kr', label: 'Kanuri' },
//   { value: 'ib', label: 'Ibibio' },
//   { value: 'tv', label: 'Tiv' },
//   { value: 'ij', label: 'Ijaw' },
//   { value: 'ur', label: 'Urhobo' },
// ];

const blockedUsersData = [
  { id: 1, name: 'Name of user', image: 'https://picsum.photos/100?random=1' },
  { id: 2, name: 'Name of user', image: 'https://picsum.photos/100?random=2' },
  { id: 3, name: 'Name of user', image: 'https://picsum.photos/100?random=3' },
  { id: 4, name: 'Name of user', image: 'https://picsum.photos/100?random=4' },
  { id: 5, name: 'Name of user', image: 'https://picsum.photos/100?random=5' },
  { id: 6, name: 'Name of user', image: 'https://picsum.photos/100?random=6' },
  { id: 7, name: 'Name of user', image: 'https://picsum.photos/100?random=7' },
  { id: 8, name: 'Name of user', image: 'https://picsum.photos/100?random=8' },
  { id: 9, name: 'Name of user', image: 'https://picsum.photos/100?random=9' },
  { id: 10, name: 'Name of user', image: 'https://picsum.photos/100?random=10' },
];


const Settings = () => {
  const [searchParams] = useSearchParams();
  const activeSection = searchParams.get('tab')

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { userData, updatingPassword, coverPhotoUrl, profilePhotoUrl, photoUploading } = useSelector((state) => state.user);
  const {
    RelationshipStatus, UserName, WorkSpace, dateofBirth, email, firstName, gender, lastName, Bio, Hobbies,
    // address, coverPhoto, phoneNumber, profilePhoto, Plan,
  } = userData ?? {}

  const coverImg = coverPhotoUrl
  const profileImg = profilePhotoUrl


  const [collapsedSections, setCollapsedSections] = useState(['profile', 'security']);
  const [isEditing, setIsEditing] = useState(false);
  const [isVisible, setIsVisible] = useState({
    email: true,
    phone: true,
    birthdate: true,
    school: true,
    work: true,
  });

  const [currentPage, setCurrentPage] = useState('info');
  const [content, setContent] = useState(null);
  const [blockedUsers, setBlockedUsers] = useState(blockedUsersData);
  const [status, setStatus] = useState(true);
  const [privateAccount, setPrivateAccount] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [avatarImage, setAvatarImage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [privacyAction, setPrivacyAction] = useState(null); // 'on' | 'off'
  const [showEmailConfirm, setShowEmailConfirm] = useState(false);
  const [enablingEmail, setEnablingEmail] = useState(false);
  const [requestingEnableOtp, setRequestingEnableOtp] = useState(false);
  const [showEnableOtp, setShowEnableOtp] = useState(false);
  const [enableOtp, setEnableOtp] = useState(['', '', '', '', '', '']);
  const [enableOtpError, setEnableOtpError] = useState('');

  const { phoneNumber } = useSelector((state) => state.user);
  const {
    settings, updatingLink, status: settingsLoading,
    authenticatorSetup, settingUpAuthenticator, verifyingAuthenticator, disablingAuthenticator,
  } = useSelector(state => state.settings)
  const { socialData, twoFA, twoFAMethod, onlineVisibility } = settings ?? {}

  const [selectedMethod, setSelectedMethod] = useState('email');
  const [authStep, setAuthStep] = useState('idle'); // 'idle' | 'setup' | 'verify'
  const [authToken, setAuthToken] = useState('');
  const [backupCodesSaved, setBackupCodesSaved] = useState(false);
  const [authError, setAuthError] = useState('');
  const [copiedBackupCodes, setCopiedBackupCodes] = useState(false);

  const [showDisableOtp, setShowDisableOtp] = useState(false);
  const [disableOtp, setDisableOtp] = useState(['', '', '', '', '', '']);
  const [disableUseBackupCode, setDisableUseBackupCode] = useState(false);
  const [disableBackupCode, setDisableBackupCode] = useState('');
  const [disableError, setDisableError] = useState('');
  const [requestingDisableOtp, setRequestingDisableOtp] = useState(false);
  const [verifyingDisable, setVerifyingDisable] = useState(false);

  const [linkedin, setLinkedin] = useState('');
  const [youtube, setYoutube] = useState('');


  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorText, setErrorText] = useState('')

  const avatar = (avatarImage ? URL.createObjectURL(avatarImage) : null) || profileImg
  const cover = (coverImage ? URL.createObjectURL(coverImage) : null) || coverImg


  const resetAuthenticatorWizard = () => {
    setAuthStep('idle');
    setAuthToken('');
    setBackupCodesSaved(false);
    setAuthError('');
    setCopiedBackupCodes(false);
  };

  const handleToggle = () => {
    if (!twoFA) {
      if (selectedMethod === 'authenticator') {
        handleStartAuthenticatorSetup();
      } else {
        setShowEmailConfirm(true);
      }
    } else {
      handleRequestDisableOtp();
    }
  };

  const resetEnableFlow = () => {
    setShowEmailConfirm(false);
    setShowEnableOtp(false);
    setEnableOtp(['', '', '', '', '', '']);
    setEnableOtpError('');
  };

  const sanitizeEnableChar = (value) => value.replace(/[^a-zA-Z0-9]/g, '');

  const handleRequestEnableOtp = async () => {
    setRequestingEnableOtp(true);
    try {
      await dispatch(send2faCode('email')).unwrap();
      setShowEmailConfirm(false);
      setShowEnableOtp(true);
    } catch (error) {
      toast.error(error.message || 'Failed to send verification code');
    } finally {
      setRequestingEnableOtp(false);
    }
  };

  const handleEnableOtpChange = (value, idx) => {
    const char = sanitizeEnableChar(value).slice(-1);
    const chars = [...enableOtp];
    chars[idx] = char;
    setEnableOtp(chars);
    if (char && idx < enableOtp.length - 1) {
      document.getElementById(`enable-otp-${idx + 1}`)?.focus();
    }
  };

  const handleEnableOtpPaste = (e) => {
    e.preventDefault();
    const pasted = sanitizeEnableChar(e.clipboardData.getData('text')).slice(0, enableOtp.length);
    if (!pasted) return;
    const chars = [...enableOtp];
    pasted.split('').forEach((char, i) => { chars[i] = char; });
    setEnableOtp(chars);
    document.getElementById(`enable-otp-${Math.min(pasted.length, enableOtp.length) - 1}`)?.focus();
  };

  const handleConfirmEnableEmail = async () => {
    const value = enableOtp.join('');
    if (value.length !== 6) {
      setEnableOtpError('Please enter the complete 6-character code');
      return;
    }
    setEnablingEmail(true);
    setEnableOtpError('');
    try {
      await dispatch(verify2faAction({ otp: value })).unwrap();
      await dispatch(toggleTwoFA('email')).unwrap();
      toast.success('2FA enabled successfully!');
      resetEnableFlow();
    } catch (error) {
      setEnableOtpError(error.message || 'Verification failed. Please try again.');
    } finally {
      setEnablingEmail(false);
    }
  };

  const handleStartAuthenticatorSetup = async () => {
    resetAuthenticatorWizard();
    setAuthStep('setup');
    try {
      await dispatch(setupAuthenticator()).unwrap();
    } catch (error) {
      console.log('Error starting authenticator setup:', error);
      toast.error(error.message || 'Failed to start authenticator setup');
      setAuthStep('idle');
    }
  };

  const handleContinueToVerify = () => {
    if (!backupCodesSaved) {
      setAuthError('Please confirm you have saved your backup codes before continuing');
      return;
    }
    setAuthError('');
    setAuthStep('verify');
  };

  const handleVerifyAuthenticatorToken = async () => {
    if (authToken.length !== 6) {
      setAuthError('Please enter the 6-digit code from your authenticator app');
      return;
    }
    setAuthError('');
    try {
      await dispatch(verifyAuthenticator(authToken)).unwrap();
      await dispatch(toggleTwoFA('authenticator')).unwrap();
      toast.success('Authenticator 2FA enabled successfully!');
      resetAuthenticatorWizard();
    } catch (error) {
      setAuthError(error.message || 'Invalid code. Please try again.');
    }
  };

  const handleCancelAuthenticatorSetup = () => {
    resetAuthenticatorWizard();
  };

  const resetDisableFlow = () => {
    setShowDisableOtp(false);
    setDisableOtp(['', '', '', '', '', '']);
    setDisableUseBackupCode(false);
    setDisableBackupCode('');
    setDisableError('');
  };

  const handleRequestDisableOtp = async () => {
    setRequestingDisableOtp(true);
    setDisableError('');
    try {
      await dispatch(send2faCode()).unwrap();
      setShowDisableOtp(true);
    } catch (error) {
      toast.error(error.message || 'Failed to send verification code');
    } finally {
      setRequestingDisableOtp(false);
    }
  };

  // Authenticator codes are numeric only; the email flow's send2fa code is a
  // 6-character alphanumeric code, so letters need to be allowed there.
  const sanitizeDisableChar = (value) =>
    twoFAMethod === 'authenticator'
      ? value.replace(/[^0-9]/g, '')
      : value.replace(/[^a-zA-Z0-9]/g, '');

  const handleDisableOtpChange = (value, idx) => {
    const char = sanitizeDisableChar(value).slice(-1);
    const digits = [...disableOtp];
    digits[idx] = char;
    setDisableOtp(digits);
    if (char && idx < disableOtp.length - 1) {
      document.getElementById(`disable-otp-${idx + 1}`)?.focus();
    }
  };

  const handleDisableOtpPaste = (e) => {
    e.preventDefault();
    const pasted = sanitizeDisableChar(e.clipboardData.getData('text')).slice(0, disableOtp.length);
    if (!pasted) return;
    const newOtp = [...disableOtp];
    pasted.split('').forEach((char, i) => { newOtp[i] = char; });
    setDisableOtp(newOtp);
    document.getElementById(`disable-otp-${Math.min(pasted.length, disableOtp.length) - 1}`)?.focus();
  };

  const handleConfirmDisable = async () => {
    let payload;
    if (twoFAMethod === 'authenticator') {
      const value = disableUseBackupCode ? disableBackupCode : disableOtp.join('');
      if (value.length !== (disableUseBackupCode ? 8 : 6)) {
        setDisableError(`Please enter the complete ${disableUseBackupCode ? '8-digit backup' : '6-digit'} code`);
        return;
      }
      payload = { code: value };
    } else {
      const value = disableOtp.join('');
      if (value.length !== 6) {
        setDisableError('Please enter the complete 6-character code');
        return;
      }
      payload = { otp: value };
    }

    setVerifyingDisable(true);
    setDisableError('');
    try {
      await dispatch(verify2faAction(payload)).unwrap();
      if (twoFAMethod === 'authenticator') {
        await dispatch(disableAuthenticator()).unwrap();
      } else {
        await dispatch(toggleTwoFA('email')).unwrap();
      }
      toast.success('Two-factor authentication has been disabled');
      resetDisableFlow();
    } catch (error) {
      setDisableError(error.message || 'Verification failed. Please try again.');
    } finally {
      setVerifyingDisable(false);
    }
  };

  const handleCopyBackupCodes = async () => {
    if (!authenticatorSetup?.backupCodes?.length) return;
    try {
      await navigator.clipboard.writeText(authenticatorSetup.backupCodes.join('\n'));
      setCopiedBackupCodes(true);
      toast.success('Backup codes copied to clipboard');
      setTimeout(() => setCopiedBackupCodes(false), 2000);
    } catch (error) {
      toast.error('Failed to copy backup codes');
    }
  };

  const handleDownloadBackupCodes = () => {
    if (!authenticatorSetup?.backupCodes?.length) return;
    const blob = new Blob([authenticatorSetup.backupCodes.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'blackdefynition-backup-codes.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const toggleStatus = async () => {
    try {
      const newStatus = !status;
      await dispatch(toggleOnlineStatusVisibility(newStatus)).unwrap();
      setStatus(newStatus);
      toast.success(`Online status visibility ${newStatus ? 'enabled' : 'disabled'}`);
    } catch (error) {
      const message = typeof error === 'string' ? error : error?.message || 'Failed to update online status visibility';
      toast.error(message);
      console.error('Toggle online status visibility failed:', message, error);
    }
  };

  const togglePrivateAccount = () => {
    if (!privateAccount) {
      // User is trying to TURN ON
      setPrivacyAction('on');
      setShowPopup(true);
    } else {
      // User is trying to TURN OFF
      setPrivacyAction('off');
      setShowPopup(true);
    }
  };


  const handlePopupAction = (action) => {
    if (action === 'accept') {
      setPrivateAccount(prev => !prev);
    }

    setShowPopup(false);
    setPrivacyAction(null);
  };


  const handleCoverChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setCoverImage(e.target.files[0]);
    }
  };

  const handleAvatarChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setAvatarImage(e.target.files[0]);
    }
  };

  const unblockUser = (id) => {
    setBlockedUsers(blockedUsers.filter(user => user.id !== id));
  };

  const handleCardClick = (content) => {
    setContent(content);
    setCurrentPage('detail');
  };

  const handleBackClick = () => {
    setCurrentPage('info');
    setContent(null);
  };
  const handleTermsClick = () => {
    navigate("/terms");
  };

  const toggleVisibility = (field) => {
    setIsVisible((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const toggleSection = (section) => {
    setCollapsedSections(prevState =>
      prevState.includes(section)
        ? prevState.filter(item => item !== section)
        : [...prevState, section]
    );
  };

  // const handleRemoveCover = () => {
  //   // Implement cover photo removal logic
  //   setCoverImage(null);
  // };
  const handleSaveImages = async () => {
    // Implement save logic
    try {
      if (coverImage) {
        const formData = new FormData();
        formData.append("image", coverImage);

        await dispatch(uploadCoverPhoto(formData)).unwrap();
        setCoverImage(null)
      }

      if (avatarImage) {
        const formData = new FormData();
        formData.append("image", avatarImage);
        await dispatch(uploadProfilePics(formData)).unwrap()
        setAvatarImage(null)
      }

      toast.success('Images updated successfully!');
    } catch (error) {
      toast.error('Failed to update images');
    }
  };

  const quickSettingsLinks = [
    { name: 'Notification settings', id: 'notification', icon: <FaBell />, description: 'Manage alerts for requests, mentions & more' },
    { name: 'Social links', id: 'social', icon: <FaLink />, description: 'Connect your LinkedIn & YouTube profiles' },
    { name: 'Profile settings', id: 'profileSettings', icon: <FaUser />, description: 'Update your contact & personal info' },
    { name: 'Avatar & Cover', id: 'avatar', icon: <FaImage />, description: 'Change your profile picture and cover photo' },
    { name: 'Privacy', id: 'privacy', icon: <FaShieldAlt />, description: 'Control who can see your activity' },
    { name: 'Password', id: 'password', icon: <FaLock />, description: 'Change your account password' },
    { name: 'Two-factor authentication', id: '2fa', icon: <FaUserLock />, description: 'Add an extra layer of login security' },
    { name: 'Disable Account', id: 'disable', icon: <FaSignOutAlt />, description: 'Deactivate your Blackdefynition account' },
  ];

  const sections = [
    { name: 'General', id: 'general', icon: <FaCog /> },
    { name: 'Notification settings', id: 'notification', icon: <FaBell /> },
    { name: 'Social links', id: 'social', icon: <FaLink /> },
    {
      name: 'Profile', id: 'profile', icon: <FaUser />, subSections: [
        { name: 'Profile settings', id: 'profileSettings', icon: <FaUser /> },
        // { name: 'My Addresses', id: 'addresses', icon: <FaMapMarkerAlt /> },
        { name: 'Avatar & Cover', id: 'avatar', icon: <FaImage /> },
        // { name: 'Verification', id: 'verification', icon: <FaCheckCircle /> },
        // { name: 'My information', id: 'information', icon: <FaInfoCircle /> },
      ]
    },
    {
      name: 'Security', id: 'security', icon: <FaShieldAlt />, subSections: [
        { name: 'Privacy', id: 'privacy', icon: <FaShieldAlt /> },
        { name: 'Password', id: 'password', icon: <FaLock /> },
        // { name: 'Manage Session', id: 'session', icon: <FaSignOutAlt /> },
        { name: 'Two-factor authentication', id: '2fa', icon: <FaUserLock /> },
      ]
    },
    // { name: 'Blocked Users', id: 'blocked', icon: <FaUserTimes /> },
    { name: 'Disable Account', id: 'disable', icon: <FaSignOutAlt /> },
  ];

  const notifications = [
    { label: 'Someone accept my friend request.', checked: true },
    { label: 'Someone send me friend request.', checked: true },
    { label: 'Someone pokes me.', checked: true },
    { label: 'Someone mentioned me.', checked: true },
  ];

  const DefaultScreen = ({ icon, title, description }) => (
    <div className="flex flex-col items-center justify-center text-center text-gray-400 mt-8 animate-fadeIn">
      <div className="text-8xl mb-4">{icon}</div>
      <p className="text-lg font-medium">{title}</p>
      <p className="text-sm mb-6">{description}</p>
    </div>
  );


  useEffect(() => {
    if (!settings) {
      dispatch(getUserSettings())
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (userData?.userId) {
      dispatch(getTwoFADetails(userData.userId))
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.userId])

  useEffect(() => {
    if (socialData) {
      setLinkedin(socialData.linkedin || '');
      setYoutube(socialData.youtube || '');
    }
  }, [socialData]);

  useEffect(() => {
    if (onlineVisibility !== undefined) {
      setStatus(onlineVisibility);
    }
  }, [onlineVisibility]);

  const disableLinkSave = () => {
    if (linkedin === socialData?.linkedin && youtube === socialData?.youtube) {
      return true
    } else {
      return false
    }
  }

  const handleUpdateSocialLink = async () => {
    // Handle save action here (e.g., API call or local storage)
    const data = {
      linkedin,
      youtube
    }

    try {
      await dispatch(updateSocialMedia(data)).unwrap();
      toast.success('Social links saved successfully!');
    } catch (error) {
      toast.error(error.message || 'Failed to save social links');
      console.error('Error saving social links:', error);
    }
  };


  const disablePasswordSave = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      return true
    }
    return false
  }

  const handleUpdatePassword = async (e) => {
    e.preventDefault()

    try { // Save the new password (e.g., via API call)
      if (newPassword !== confirmPassword) {
        setErrorText('new password does not match your confirmed password')
        return
      }

      const data = {
        email: email,
        currentPassword,
        newPassword
      }

      await dispatch(updatePassword(data)).unwrap()

      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')

      toast.success('password updated successfully')

    } catch (error) {
      toast.error(error.message)
      console.log('error saving password: ', error.message)
    }

  };

  const handleDeleteAccount = async () => {
    try {
      await dispatch(deleteAccount()).unwrap()
      dispatch({ type: 'RESET_STORE' })
      navigate("/login", { replace: true })


    }
    catch (error) {
      console.log('unable to disable account; ', error.message)
    }
  }

  const renderContent = () => {
    switch (activeSection) {
      case 'notification':
        return (
          <div className="bg-customGray p-4 rounded-md">
            <div className="bg-customDark p-4 rounded-md w-full md:w-1/2 mx-auto mt-4">
              <h2 className="text-2xl font-bold mb-4">Notification Setting</h2>

              <div className="text-left">
                <p className="font-bold mb-2">Notify me when</p>

                <div className="flex flex-col space-y-2">
                  {notifications.map((notification, index) => (
                    <label key={index} className="flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 accent-[#BE9524] text-cutombg-customGray"
                        defaultChecked={notification.checked}
                      />
                      <span className="ml-2 text-white">{notification.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

        );
      case 'social':
        return (
          <div className="bg-customGray p-4 rounded-md ">
            <div className="bg-customDark p-4 rounded-md w-full md:w-2/3 mx-auto mt-4">
              <h2 className="text-2xl font-bold mb-4">Social Links</h2>
              <p className="mb-4">Please drop your profile link to all the social websites listed below</p>

              <div className="grid grid-cols-2 gap-4 mt-4">
                <input
                  value={linkedin}
                  onChange={e => setLinkedin(e.target.value)}
                  type="text"
                  placeholder="LinkedIn Link"
                  className="bg-customGray p-2 rounded-md text-white w-full"
                />

                <input
                  value={youtube}
                  onChange={e => setYoutube(e.target.value)}
                  type="text"
                  placeholder="YouTube Link"
                  className="bg-customGray p-2 rounded-md text-white w-full"
                />
              </div>

              <button
                disabled={updatingLink || disableLinkSave()}
                onClick={handleUpdateSocialLink}
                style={{ opacity: disableLinkSave() ? 0.6 : 1 }}
                className="mt-[20%] bg-customGray text-white p-2 rounded-md w-full"
              >
                {updatingLink ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>

        );
      case 'profileSettings':
        return (
          <div className="flex items-center justify-center bg-customGray text-white p-4 md:p-6">
            <div className="relative w-full max-w-2xl bg-[#1C1B19] rounded-xl shadow-lg 
      overflow-y-auto md:max-h-[80vh] max-h-none scrollbar-hide p-4 md:p-6">

              {/* Back button */}
              {isEditing && (
                <button
                  onClick={() => setIsEditing(false)}
                  className="absolute top-6 left-4 z-10 flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
                  aria-label="Back to profile"
                >
                  <IoMdArrowRoundBack />
                </button>
              )}

              {/* Profile Header */}
              <div className="p-4 justify-end flex border-b border-gray-700">
                <h2 className="text-xl">Profile Settings</h2>
              </div>

              {/* Main Content */}
              <div className="p-1">
                {!isEditing ? (
                  <div className="space-y-8">

                    {/* Profile Summary */}
                    <div className="
        flex flex-col sm:flex-row gap-6 sm:gap-8 items-start 
        bg-customDark p-4 rounded-xl shadow-md
      ">
                      <div className="flex-shrink-0">
                        <div className="
            w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-700 
            flex items-center justify-center overflow-hidden
          ">
                          <span className="text-3xl sm:text-4xl font-semibold">
                            {firstName?.[0]}{lastName?.[0]}
                          </span>
                        </div>
                      </div>

                      <div className="flex flex-col">
                        <h3 className="text-xl sm:text-2xl font-bold">
                          {firstName} {lastName}
                        </h3>

                        {UserName && (
                          <div className="text-sm text-gray-400">@{UserName}</div>
                        )}

                        {Bio && (
                          <p className="mt-3 text-gray-300 text-sm leading-relaxed">
                            {Bio}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Sections Wrapper */}
                    <div className="space-y-6">

                      <div className="bg-customDark p-2 rounded-xl shadow-md">
                        <ProfileSection
                          title="Contact Information"
                          items={[
                            {
                              label: "Email",
                              value: isVisible.email ? email : "••••••••",
                              icon: isVisible.email ? faEye : faEyeSlash,
                              onToggle: () => toggleVisibility("email"),
                              onEdit: () => setIsEditing(true)
                            },
                            {
                              label: "Phone",
                              value: isVisible.phone
                                ? phoneNumber || "Not provided"
                                : "••••••••",
                              icon: isVisible.phone ? faEye : faEyeSlash,
                              onToggle: () => toggleVisibility("phone"),
                              onEdit: () => setIsEditing(true)
                            }
                          ]}
                        />
                      </div>

                      <div className="bg-customDark p-2 rounded-xl shadow-md">
                        <ProfileSection
                          title="Personal Information"
                          items={[
                            {
                              label: "Birthday",
                              value: isVisible.birthdate
                                ? moment(dateofBirth).format('DD/MM/YYYY')
                                : "••••••••",
                              icon: isVisible.birthdate ? faEye : faEyeSlash,
                              onToggle: () => toggleVisibility("birthdate"),
                              onEdit: () => setIsEditing(true)
                            },
                            {
                              label: "Gender",
                              value: gender === 'male' ? 'Male' : "Female",
                              showEdit: false
                            }
                          ]}
                        />
                      </div>

                      <div className="bg-customDark p-2 rounded-xl shadow-md">
                        <ProfileSection
                          title="Hobbies & Relationship"
                          items={[
                            {
                              label: "Hobbies",
                              value: isVisible.school
                                ? Hobbies || 'Not specified'
                                : "••••••••",
                              icon: isVisible.school ? faEye : faEyeSlash,
                              onToggle: () => toggleVisibility("school"),
                              onEdit: () => setIsEditing(true)
                            },
                            {
                              label: "Relationship Status",
                              value: RelationshipStatus || 'Not specified',
                              showEdit: false
                            }
                          ]}
                        />
                      </div>

                      <div className="bg-customDark p-2 rounded-xl shadow-md">
                        <ProfileSection
                          title="Professional Information"
                          items={[
                            {
                              label: "Profession",
                              value: isVisible.work ? WorkSpace : "••••••••",
                              icon: isVisible.work ? faEye : faEyeSlash,
                              onToggle: () => toggleVisibility("work"),
                              onEdit: () => setIsEditing(true)
                            }
                          ]}
                        />
                      </div>

                    </div>
                  </div>
                ) : (
                  <div className="mt-2">
                    <ProfileEdit close={() => setIsEditing(false)} />
                  </div>
                )}
              </div>

            </div>
          </div>

        );

      // case 'addresses':
      // return (
      //   <div className="bg-customGray p-4 rounded-md">
      //     {/* <h2 className="text-2xl font-bold mb-4">My Addresses</h2> */}
      //     <div className="flex flex-col items-center bg-customDark p-6 rounded-lg w-full max-w-2xl mx-auto">
      //       <h1 className="text-white text-lg mb-4">My Addresses</h1>
      //       <div className="flex w-full">
      //         <div className="w-1/2 p-4">
      //           <div className="w-full h-48 bg-customGray rounded-lg flex items-center justify-center">
      //             <label className="cursor-pointer text-white flex flex-col items-center">
      //               <svg className="w-12 h-12 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
      //               </svg>
      //               <span>Add location</span>
      //               <input type="file" className="hidden" />
      //             </label>
      //           </div>
      //         </div>
      //         <div className="w-1/2 p-4 flex flex-col space-y-4">
      //           <select className="w-full p-2 bg-customGray text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white">
      //             <option value="">State</option>
      //             <option value="state1">State 1</option>
      //             <option value="state2">State 2</option>
      //           </select>
      //           <select className="w-full p-2 bg-customGray text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white">
      //             <option value="">Country</option>
      //             <option value="country1">Country 1</option>
      //             <option value="country2">Country 2</option>
      //           </select>
      //           <button className="px-4 py-2 bg-customGray text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white">Save</button>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
      case 'avatar':
        return (
          <div className="bg-customGray p-4 rounded-md animate-fadeIn">
            <div className="flex flex-col items-center bg-customDark p-4 md:p-6 rounded-lg">
              {/* Cover Photo Section */}
              <div className="w-full relative group">
                {cover ? (
                  <div className="relative">
                    <img
                      src={cover}
                      alt="Cover"
                      className="w-full h-[200px] md:h-[300px] lg:h-[400px] object-cover rounded-lg transition-all bg-gray-500 duration-300"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100">
                      <label className="cursor-pointer p-2 bg-black bg-opacity-60 rounded-full">
                        <FiCamera className="w-6 h-6 text-white" />
                        <input
                          type="file"
                          className="hidden"
                          onChange={handleCoverChange}
                          accept="image/*"
                        />
                      </label>
                      {/* {cover && (
                        <button
                          onClick={handleRemoveCover}
                          className="ml-2 p-2 bg-black bg-opacity-60 rounded-full"
                          aria-label="Remove cover photo"
                        >
                          <FiTrash2 className="w-6 h-6 text-red-400" />
                        </button>
                      )} */}
                    </div>
                  </div>
                ) : (
                  <div className="w-full h-32 md:h-40 lg:h-48 bg-customGray rounded-lg flex flex-col items-center justify-center border-2 border-dashed border-gray-600 hover:border-customGold transition-colors duration-300">
                    <label className="cursor-pointer flex flex-col items-center">
                      <FiImage className="w-10 h-10 mb-2 text-gray-400" />
                      <span className="text-sm md:text-base text-gray-400">Upload Cover Photo</span>
                      <input
                        type="file"
                        className="hidden"
                        onChange={handleCoverChange}
                        accept="image/*"
                      />
                    </label>
                  </div>
                )}
              </div>

              {/* Avatar Section */}
              <div className="relative -mt-12 md:-mt-16 group">
                <div className="relative">
                  {avatar ? (
                    <>
                      <img
                        src={avatar}
                        alt="Avatar"
                        className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 rounded-full border-4 border-customDark object-cover shadow-lg transition-all duration-300"
                      />
                      <div className="absolute inset-0 rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-40 flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100">
                        <label className="cursor-pointer p-2 bg-black bg-opacity-60 rounded-full">
                          <FiCamera className="w-6 h-6 text-white" />
                          <input
                            type="file"
                            className="hidden"
                            onChange={handleAvatarChange}
                            accept="image/*"
                          />
                        </label>
                      </div>
                    </>
                  ) : (
                    <div className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 bg-customGray rounded-full flex items-center justify-center border-4 border-customDark shadow-lg">
                      <label className="cursor-pointer flex flex-col items-center">
                        <FiUser className="w-10 h-10 text-gray-400" />
                        <input
                          type="file"
                          className="hidden"
                          onChange={handleAvatarChange}
                          accept="image/*"
                        />
                      </label>
                    </div>
                  )}
                </div>
              </div>

              {/* Save Button */}
              <button
                className={`mt-4 md:mt-6 px-6 py-2 rounded-lg flex items-center justify-center min-w-[120px] ${photoUploading || (!avatarImage && !coverImage)
                  ? 'bg-customGold bg-opacity-70 cursor-not-allowed'
                  : 'bg-customGold hover:bg-opacity-90 transition-colors'
                  }`}
                disabled={(!avatarImage && !coverImage) || photoUploading}
                onClick={handleSaveImages}
              >
                {photoUploading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Saving...
                  </>
                ) : (
                  'Save Changes'
                )}
              </button>
            </div>
          </div>

        );

      case 'verification':
        return (
          <div className="bg-customGray p-4 rounded-md">
            <h2 className="text-2xl font-bold mb-4">Verification</h2>
          </div>
        );

      case 'information':
        return (
          <div className="flex items-center justify-center min-h-screen bg-customGray text-white p-4">
            {currentPage === 'info' ? (
              <div className="w-full max-w-4xl">
                <h2 className="text-2xl font-bold mb-4">Download My Information</h2>
                <p className="mb-6">Please choose which information you would like to download</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div
                    className="bg-customDark p-8 rounded-md flex flex-col items-center cursor-pointer transform transition duration-300 hover:scale-105"
                    onClick={() => handleCardClick('posts')}
                  >
                    <AiOutlineFile className="text-4xl mb-4" />
                    <p>My posts</p>
                  </div>
                  <div
                    className="bg-customDark p-8 rounded-md flex flex-col items-center cursor-pointer transform transition duration-300 hover:scale-105"
                    onClick={() => handleCardClick('friends')}
                  >
                    <AiOutlineUser className="text-4xl mb-4" />
                    <p>My pals</p>
                  </div>
                  <div
                    className="bg-customDark p-8 rounded-md flex flex-col items-center cursor-pointer transform transition duration-300 hover:scale-105"
                    onClick={() => handleCardClick('groups')}
                  >
                    <AiOutlineTeam className="text-4xl mb-4" />
                    <p>My groups</p>
                  </div>
                  <div
                    className="bg-customDark p-8 rounded-md flex flex-col items-center cursor-pointer transform transition duration-300 hover:scale-105"
                    onClick={() => handleCardClick('reels')}
                  >
                    <AiOutlineVideoCamera className="text-4xl mb-4" />
                    <p>My flips</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full max-w-4xl">
                {/* Back Button */}
                <button onClick={handleBackClick} className="text-white mb-4">
                  <AiOutlineArrowLeft className="text-2xl" />
                </button>

                {/* Content Rendering */}
                {content === "posts" && (
                  <div className="bg-customDark p-8 items-center justify-center rounded-md">
                    <h3 className="text-xl font-semibold mb-4">My Posts</h3>
                    {/* Replace with actual content or show Default Screen */}
                    <MyPost />
                    {/* Replace this with conditional rendering if needed */}
                  </div>
                )}

                {content === "friends" && (
                  <RightSideFriend showHeader={false} />
                )}

                {content === "groups" && (
                  <div className="bg-customDark p-8 rounded-md">
                    <h3 className="text-xl font-semibold mb-4">My Groups</h3>
                    {/* Default Screen for no groups */}
                    <DefaultScreen
                      icon={<AiOutlineUsergroupAdd className="text-yellow-500" />}
                      title="No Groups Yet"
                      description="You haven’t joined any groups yet. Explore and find your interests!"
                    />
                  </div>
                )}

                {content === "reels" && (
                  <div className="bg-customDark p-8 rounded-md">
                    <h3 className="text-xl font-semibold mb-4">My Flips</h3>
                    {/* Default Screen for no reels */}
                    <DefaultScreen
                      icon={<AiOutlineVideoCamera className="text-yellow-500" />}
                      title="No Flips Found"
                      description="You haven’t created or saved any reels yet. Start sharing your moments!"
                    />
                  </div>
                )}

                {/* Example Fallback for Empty Content */}
                {!["posts", "friends", "groups", "reels"].includes(content) && (
                  <div className="bg-customDark p-8 rounded-md">
                    <DefaultScreen
                      icon={<AiOutlineFileAdd className="text-yellow-500" />}
                      title="Nothing to Display"
                      description="Please select a valid category to view its content."
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        );

      case 'privacy':
        return (
          <div className="bg-customGray p-4 rounded-md">
            <div className="bg-customDark text-white p-6 max-w-md mx-auto mt-10 rounded-lg">
              <h2 className="text-2xl font-bold mb-6">Privacy Settings</h2>
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <span>Online Status Visibility</span>
                  <div className="flex items-center space-x-2">
                    <span>{status ? 'Visible' : 'Hidden'}</span>
                    <button
                      onClick={toggleStatus}
                      className={`relative inline-flex items-center h-6 rounded-full w-11 ${status ? 'bg-customGray' : 'bg-customGray'}`}
                    >
                      <span
                        className={`transform transition ease-in-out duration-200 inline-block w-4 h-4 rounded-full bg-[#BE9524] ${status ? 'translate-x-6' : 'translate-x-1'}`}
                      ></span>
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span>Private Account</span>

                  <div className="flex items-center space-x-2">
                    <span>{privateAccount ? 'On' : 'Off'}</span>

                    <button
                      onClick={togglePrivateAccount}
                      className="relative inline-flex items-center h-6 w-11 rounded-full bg-customGray"
                    >
                      <span
                        className={`inline-block w-4 h-4 rounded-full bg-[#BE9524] transform transition ${privateAccount ? 'translate-x-6' : 'translate-x-1'
                          }`}
                      />
                    </button>
                  </div>
                </div>
              </div>
              {/* <button
                type="submit"
                className="w-full py-2 mt-[10%] rounded bg-customGray cursor-not-allowed"
              >
                Save
              </button> */}
            </div>

            {showPopup && (
              <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                <div className="bg-customDark text-white p-6 max-w-md mx-auto rounded-lg">
                  <div className="flex flex-col items-center">
                    <div className="mb-4">
                      <img src={Privacy} alt="Lock Icon" className="w-12 h-12" />
                    </div>
                    <h2 className="text-2xl font-bold mb-2">
                      {privacyAction === 'on' ? 'Private Account' : 'Public Account'}
                    </h2>

                    <p className="mb-6 text-center">
                      {privacyAction === 'on'
                        ? 'Enabling this option will restrict users from viewing your photos, posts, and stories on your profile.'
                        : 'Disabling this option will allow anyone to view your photos, posts, and stories on your profile.'}
                    </p>

                    <div className="flex space-x-4">
                      <button
                        onClick={() => handlePopupAction('accept')}
                        className="bg-[#BE9524] text-black py-2 px-4 rounded"
                      >
                        {privacyAction === 'on' ? 'Turn On' : 'Turn Off'}
                      </button>

                      <button
                        onClick={() => handlePopupAction('decline')}
                        className="bg-customGray text-white py-2 px-4 rounded"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );



      case 'password':
        return (
          <div className="bg-customGray p-4 rounded-md">
            {/* <h2 className="text-2xl font-bold mb-4">Password</h2> */}
            <div className="bg-customDark text-white p-6 max-w-2xl mx-auto mt-10 rounded-lg">
              <h2 className="text-2xl font-bold mb-6">Change Password</h2>
              <p className=" mb-6">
                Choose a strong password and use at least 8 characters. Avoid passwords that are too obvious or from another site, or something. Please note that you can only change your password once in 3 months before you can make another change of password.
              </p>
              <form onSubmit={handleUpdatePassword}>
                <div className="mb-4">
                  <label className="block mb-2" htmlFor="currentPassword">Current password</label>
                  <input required value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} type="password" id="currentPassword" className="w-full p-2 rounded bg-customGray text-gray-200" />
                </div>
                <div className="mb-4">
                  <label className="block mb-2" htmlFor="newPassword">New password</label>
                  <input required value={newPassword} onChange={e => setNewPassword(e.target.value)} type="password" id="newPassword" className="w-full p-2 rounded bg-customGray text-gray-200" />
                </div>
                <div className="mb-6">
                  <label className="block mb-2" htmlFor="confirmPassword">Confirm password</label>
                  <input required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} type="password" id="confirmPassword" className="w-full p-2 rounded bg-customGray text-gray-200" />
                </div>
                {errorText && <p className='text-red-700' >{errorText}</p>}
                <button disabled={updatingPassword || disablePasswordSave()} style={{ opacity: disablePasswordSave() ? 0.6 : 1 }} type="submit" className="w-full py-2 rounded bg-customGray">{updatingPassword ? 'Saving...' : 'Save'}</button>
              </form>
            </div>
          </div>
        );
      case '2fa': {
        const wizardActive = showEmailConfirm || showEnableOtp || authStep !== 'idle' || showDisableOtp;
        return (
          <div className="bg-customGray p-4 rounded-md">
            {!wizardActive && (
              <div className="flex flex-col items-center text-center rounded-md mt-4">
                <FaUserLock className="text-6xl mb-4" />
                <p className="mb-6">
                  {!twoFA
                    ? "Turn on 2-step login to level up your account’s security. Once turned on, you'll use both your password and a security code to log in."
                    : `Two-factor authentication is currently enabled via ${twoFAMethod === 'authenticator' ? 'an authenticator app' : 'email'}.`}
                </p>
              </div>
            )}

            <div className="
      bg-customDark p-4 flex flex-col items-center rounded-md
      w-full sm:w-3/4 md:w-1/2 mx-auto mt-4
    ">
              {!wizardActive && (
                <div className="flex items-center justify-between w-full mb-4">
                  <div className="flex flex-col">
                    <h2 className="text-[14px] font-bold mb-1">Two-Factor Authentication</h2>
                    <span className="text-[16px]">
                      {twoFA ? `Enabled (${twoFAMethod === 'authenticator' ? 'Authenticator app' : 'Email'})` : "Disabled"}
                    </span>
                  </div>
                  <button
                    onClick={handleToggle}
                    disabled={disablingAuthenticator || requestingDisableOtp}
                    className={`relative inline-flex items-center h-6 rounded-full w-11 ${twoFA ? "bg-green-200" : "bg-customGray"
                      }`}
                  >
                    <span
                      className={`transform transition ease-in-out duration-200 inline-block w-4 h-4 rounded-full bg-[#BE9524] ${twoFA ? "translate-x-6" : "translate-x-1"
                        }`}
                    ></span>
                  </button>
                </div>
              )}

              {/* Method selector - only shown while 2FA is off and no wizard is running */}
              {!twoFA && !wizardActive && (
                <div className="w-full mb-4">
                  <p className="text-sm text-gray-400 mb-2">Choose a verification method:</p>
                  <div className="grid grid-cols-2 gap-3">
                    <button
                      type="button"
                      onClick={() => setSelectedMethod('email')}
                      className={`p-3 rounded-lg border text-sm text-left transition-colors ${selectedMethod === 'email' ? 'border-[#BE9524] bg-black/30' : 'border-gray-700 hover:border-gray-500'}`}
                    >
                      <div className="font-semibold">Email</div>
                      <div className="text-xs text-gray-400">Get a code by email each time you log in</div>
                    </button>
                    <button
                      type="button"
                      onClick={() => setSelectedMethod('authenticator')}
                      className={`p-3 rounded-lg border text-sm text-left transition-colors ${selectedMethod === 'authenticator' ? 'border-[#BE9524] bg-black/30' : 'border-gray-700 hover:border-gray-500'}`}
                    >
                      <div className="font-semibold">Authenticator app</div>
                      <div className="text-xs text-gray-400">Use Google Authenticator, Authy, 1Password, etc.</div>
                    </button>
                  </div>
                </div>
              )}

              {/* Email 2FA enable confirmation */}
              {showEmailConfirm && (
                <div className="w-full mt-4">
                  <p className="mb-4 text-sm sm:text-base">
                    Enabling email 2FA means you'll need to enter a code sent to{' '}
                    <span className="font-semibold">{email}</span> each time you log in,
                    in addition to your password.
                  </p>

                  <div className="flex gap-3">
                    <button
                      disabled={requestingEnableOtp}
                      onClick={handleRequestEnableOtp}
                      className="bg-[#BE9524] text-black py-2 px-4 rounded w-full sm:w-auto disabled:opacity-70"
                    >
                      {requestingEnableOtp ? 'Sending code...' : 'Continue'}
                    </button>
                    <button
                      onClick={() => setShowEmailConfirm(false)}
                      disabled={requestingEnableOtp}
                      className="bg-customGray text-white py-2 px-4 rounded w-full sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {/* Email 2FA enable verification step */}
              {showEnableOtp && (
                <div className="w-full mt-4">
                  <p className="mb-4 text-sm sm:text-base">
                    A verification code has been sent to <span className="font-semibold">{email}</span>.
                    Enter it below to confirm we can reach you at this address before turning on 2FA.
                  </p>

                  <div className="flex justify-center mb-4 flex-wrap">
                    {enableOtp.map((char, idx) => (
                      <input
                        key={idx}
                        id={`enable-otp-${idx}`}
                        type="text"
                        value={char}
                        onChange={(e) => handleEnableOtpChange(e.target.value, idx)}
                        onPaste={handleEnableOtpPaste}
                        maxLength="1"
                        className="w-10 h-10 m-1 text-center rounded-md border bg-black border-gray-300 sm:w-12 sm:h-12"
                        autoFocus={idx === 0}
                      />
                    ))}
                  </div>

                  <div className="text-center mb-4">
                    <button
                      type="button"
                      onClick={handleRequestEnableOtp}
                      disabled={requestingEnableOtp}
                      className="text-customGold text-sm font-medium hover:underline focus:outline-none disabled:opacity-60"
                    >
                      {requestingEnableOtp ? 'Sending...' : 'Resend code'}
                    </button>
                  </div>

                  {enableOtpError && <p className="text-red-700 mb-3">{enableOtpError}</p>}

                  <div className="flex gap-3">
                    <button
                      disabled={enablingEmail}
                      onClick={handleConfirmEnableEmail}
                      className="bg-[#BE9524] text-black py-2 px-4 rounded w-full sm:w-auto disabled:opacity-70"
                    >
                      {enablingEmail ? 'Verifying...' : 'Verify & Enable'}
                    </button>
                    <button
                      onClick={resetEnableFlow}
                      disabled={enablingEmail}
                      className="bg-customGray text-white py-2 px-4 rounded w-full sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {/* Disable 2FA verification step */}
              {showDisableOtp && (
                <div className="w-full mt-4">
                  <p className="mb-4 text-sm sm:text-base">
                    {twoFAMethod === 'authenticator'
                      ? (disableUseBackupCode
                        ? 'Enter one of your unused 8-digit backup codes to confirm disabling 2FA.'
                        : 'Enter the 6-digit code from your authenticator app to confirm disabling 2FA.')
                      : <>A verification code has been sent to <span className="font-semibold">{email}</span>. Enter it below to confirm disabling 2FA.</>}
                  </p>

                  {twoFAMethod === 'authenticator' && disableUseBackupCode ? (
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={8}
                      value={disableBackupCode}
                      onChange={(e) => setDisableBackupCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 8))}
                      placeholder="Backup code"
                      className="w-full mb-4 text-center text-2xl tracking-widest bg-black border border-gray-600 rounded-md py-2"
                      autoFocus
                    />
                  ) : (
                    <div className="flex justify-center mb-4 flex-wrap">
                      {disableOtp.map((digit, idx) => (
                        <input
                          key={idx}
                          id={`disable-otp-${idx}`}
                          type="text"
                          {...(twoFAMethod === 'authenticator' ? { inputMode: 'numeric', pattern: '[0-9]*' } : {})}
                          value={digit}
                          onChange={(e) => handleDisableOtpChange(e.target.value, idx)}
                          onPaste={handleDisableOtpPaste}
                          maxLength="1"
                          className="w-10 h-10 m-1 text-center rounded-md border bg-black border-gray-300 sm:w-12 sm:h-12"
                          autoFocus={idx === 0}
                        />
                      ))}
                    </div>
                  )}

                  {twoFAMethod === 'authenticator' && (
                    <div className="text-center mb-4">
                      <button
                        type="button"
                        onClick={() => setDisableUseBackupCode((prev) => !prev)}
                        className="text-customGold text-sm font-medium hover:underline focus:outline-none"
                      >
                        {disableUseBackupCode ? 'Use authenticator app instead' : 'Use a backup code instead'}
                      </button>
                    </div>
                  )}

                  {twoFAMethod !== 'authenticator' && (
                    <div className="text-center mb-4">
                      <button
                        type="button"
                        onClick={handleRequestDisableOtp}
                        disabled={requestingDisableOtp}
                        className="text-customGold text-sm font-medium hover:underline focus:outline-none disabled:opacity-60"
                      >
                        {requestingDisableOtp ? 'Sending...' : 'Resend code'}
                      </button>
                    </div>
                  )}

                  {disableError && <p className="text-red-700 mb-3">{disableError}</p>}

                  <div className="flex gap-3">
                    <button
                      disabled={verifyingDisable}
                      onClick={handleConfirmDisable}
                      className="bg-[#BE9524] text-black py-2 px-4 rounded w-full sm:w-auto disabled:opacity-70"
                    >
                      {verifyingDisable ? 'Verifying...' : 'Confirm & Disable'}
                    </button>
                    <button
                      onClick={resetDisableFlow}
                      disabled={verifyingDisable}
                      className="bg-customGray text-white py-2 px-4 rounded w-full sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {/* Authenticator setup step: QR code + secret + backup codes */}
              {authStep === 'setup' && (
                <div className="w-full mt-4 text-left">
                  {settingUpAuthenticator && !authenticatorSetup ? (
                    <p className="text-sm text-gray-400 text-center">Generating your authenticator secret...</p>
                  ) : authenticatorSetup && (
                    <>
                      <p className="mb-3 text-sm">
                        Scan this QR code with your authenticator app, or enter the secret manually.
                      </p>
                      <div className="flex justify-center mb-3">
                        <img
                          src={authenticatorSetup.qrCode}
                          alt="Authenticator QR code"
                          className="w-40 h-40 bg-white p-2 rounded-md"
                        />
                      </div>
                      <div className="mb-4">
                        <p className="text-xs text-gray-400 mb-1">Can't scan? Enter this code manually:</p>
                        <p className="font-mono text-sm bg-black/40 p-2 rounded break-all select-all">
                          {authenticatorSetup.secret}
                        </p>
                      </div>

                      <p className="mb-2 text-sm font-semibold">Backup codes</p>
                      <p className="text-xs text-gray-400 mb-2">
                        Save these codes somewhere safe. Each can be used once to log in if you lose access to your authenticator app.
                      </p>
                      <div className="grid grid-cols-2 gap-2 mb-3 font-mono text-sm">
                        {authenticatorSetup.backupCodes?.map((backupCode, idx) => (
                          <div key={idx} className="bg-black/40 p-2 rounded text-center">{backupCode}</div>
                        ))}
                      </div>
                      <div className="flex gap-3 mb-4">
                        <button
                          type="button"
                          onClick={handleCopyBackupCodes}
                          className="flex items-center gap-2 text-xs text-customGold hover:underline"
                        >
                          <FaCopy /> {copiedBackupCodes ? 'Copied!' : 'Copy all'}
                        </button>
                        <button
                          type="button"
                          onClick={handleDownloadBackupCodes}
                          className="flex items-center gap-2 text-xs text-customGold hover:underline"
                        >
                          <FaDownload /> Download .txt
                        </button>
                      </div>

                      <label className="flex items-center gap-2 mb-4 text-sm cursor-pointer">
                        <input
                          type="checkbox"
                          checked={backupCodesSaved}
                          onChange={(e) => setBackupCodesSaved(e.target.checked)}
                          className="rounded border-gray-600 text-customGold focus:ring-customGold"
                        />
                        I have saved my backup codes in a safe place
                      </label>

                      {authError && <p className="text-red-700 text-sm mb-3">{authError}</p>}

                      <div className="flex gap-3">
                        <button
                          onClick={handleContinueToVerify}
                          disabled={!backupCodesSaved}
                          className={`py-2 px-4 rounded w-full sm:w-auto ${backupCodesSaved ? 'bg-[#BE9524] text-black' : 'bg-customGray text-gray-400 cursor-not-allowed'}`}
                        >
                          Continue
                        </button>
                        <button
                          onClick={handleCancelAuthenticatorSetup}
                          className="bg-customGray text-white py-2 px-4 rounded w-full sm:w-auto"
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Authenticator verify step: confirm a live 6-digit token */}
              {authStep === 'verify' && (
                <div className="w-full mt-4 text-left">
                  <p className="mb-4 text-sm">
                    Enter the 6-digit code currently shown in your authenticator app to confirm setup.
                  </p>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={6}
                    value={authToken}
                    onChange={(e) => setAuthToken(e.target.value.replace(/[^0-9]/g, '').slice(0, 6))}
                    placeholder="123456"
                    className="w-full mb-4 text-center text-2xl tracking-widest bg-black border border-gray-600 rounded-md py-2"
                    autoFocus
                  />
                  {authError && <p className="text-red-700 text-sm mb-3">{authError}</p>}
                  <div className="flex gap-3">
                    <button
                      onClick={handleVerifyAuthenticatorToken}
                      disabled={authToken.length !== 6 || verifyingAuthenticator}
                      className={`py-2 px-4 rounded w-full sm:w-auto ${authToken.length === 6 ? 'bg-[#BE9524] text-black' : 'bg-customGray text-gray-400 cursor-not-allowed'}`}
                    >
                      {verifyingAuthenticator ? 'Verifying...' : 'Verify & Enable'}
                    </button>
                    <button
                      onClick={handleCancelAuthenticatorSetup}
                      className="bg-customGray text-white py-2 px-4 rounded w-full sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

        );
      }

      case 'blocked':
        return (
          <div className="bg-customGray p-4 rounded-md animate-fadeIn">
            <div className="bg-customDark text-white p-6 max-w-4xl mx-auto mt-10 rounded-lg animate-fadeIn">
              <h2 className="text-2xl font-bold mb-6">Blocked Users</h2>
              <p className=" mb-6">
                You and the user won't get any notifications, calls or messages from each other. So unblock users to get all the notifications, calls, and you will be able to message one another.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {blockedUsers.map(user => (
                  <div key={user.id} className="flex items-center justify-between bg-customGray p-4 rounded-lg">
                    <div className="flex items-center">
                      <img src={user.image} alt={user.name} className="w-10 h-10 rounded-full mr-4" />
                      <span>{user.name}</span>
                    </div>
                    <button
                      onClick={() => unblockUser(user.id)}
                      className="bg-customDark  py-2 px-4 rounded hover:bg-gray-600"
                    >
                      Unblock
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      case 'disable':
        return (
          <div className="flex items-center justify-center min-h-screen bg-customGray text-white p-4">
            <div className="bg-customDark p-8 rounded-md w-full max-w-md">
              <h2 className="text-2xl font-bold mb-4">Disable Account</h2>
              <div className="flex flex-col items-center text-center">
                <AiOutlineDelete className="text-6xl mb-4" />
                <p className="mb-6">Are you sure you want to delete your account, and leave our network?</p>
                <div className="flex space-x-4">
                  <button onClick={handleDeleteAccount} className="bg-customGray text-white py-2 px-4 rounded hover:bg-customGold transition duration-300">
                    Disable Account
                  </button>
                  <button className="bg-customGray py-2 px-4 rounded hover:bg-customGold transition duration-300">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div>
            <h2 className="text-2xl font-bold mb-4">General Settings</h2>

            {/* Quick Settings */}
            <div className="bg-customGray p-4 rounded-md mb-4">
              <h3 className="text-xl font-semibold mb-4">Quick Settings</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {quickSettingsLinks.map((link) => (
                  <Link
                    key={link.id}
                    to={`?tab=${link.id}`}
                    className="flex items-center gap-3 bg-customDark p-3 rounded-lg hover:bg-black/30 transition-colors duration-200"
                  >
                    <span className="text-[#BE9524] text-lg">{link.icon}</span>
                    <div>
                      <div className="text-sm font-medium">{link.name}</div>
                      <div className="text-xs text-gray-400">{link.description}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* About Section */}
            <div className="bg-customGray p-4 rounded-md">
              <h3 className="text-xl font-semibold mb-2">About</h3>
              <p className="mb-2">What Blackdefynition is all about...</p>
              <p className="mb-2">Benefits of using our platform include seamless collaboration, interactive features, and personalized user experiences.</p>
              <p className="mb-2">
                <button
                  onClick={handleTermsClick}
                  className="text-customGold hover:underline transition duration-200"
                >
                  Terms and Conditions
                </button>
              </p>
            </div>

            {/* Language Section */}
            {/* <div className="bg-customGray p-4 mt-4 rounded-md">
              <h3 className="text-xl font-semibold mb-2">Language</h3>
              <div className="flex flex-col space-y-4">
                <Select
                  components={animatedComponents}
                  options={languages}
                  placeholder="Select a language"
                  className="bg-customDark rounded-md text-white"
                  onChange={(option) => setSelectedLanguage(option)}
                  value={selectedLanguage}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: '#1C1B19',
                      borderColor: 'transparent',
                    }),
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: '#1C1B19',
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: 'white',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isSelected ? '#BE9524' : '#1C1B19',
                      color: state.isSelected ? 'black' : 'white',
                      '&:hover': {
                        backgroundColor: '#BE9524',
                        color: 'black',
                      },
                    }),
                  }}
                />
              </div>
            </div> */}

            {/* Orders and Payments */}
            {/* <div className="bg-customGray p-4 mt-4 rounded-md">
              <h3 className="text-xl font-semibold mb-2">Your Orders and Payments</h3>
              <div className="flex items-center mb-2">
                <AiOutlineInfoCircle className="mr-2" />
                <p>Contact info</p>
              </div>
              <div className="flex items-center mb-2">
                <AiOutlineCreditCard className="mr-2" />
                <p>Payment method</p>
              </div>
              <div className="flex items-center mb-2">
                <AiOutlineQuestionCircle className="mr-2" />
                <p>Help and support</p>
              </div>
            </div> */}
          </div>
        );
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  }
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const closeOnClick = ["general", "notification", "social", "disable"];

  return (
    <div className="flex h-[calc(100vh-4rem)] flex-col text-white">
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 bg-black/60 md:hidden z-40"
        ></div>
      )}

      <div className="flex h-full">

        {/* Sidebar */}
        <div
          className={`
          p-4 h-full flex flex-col overflow-y-auto scrollbar-hide bg-customDark
          transition-transform duration-300
          md:relative md:w-[20%] md:translate-x-0
          fixed top-0 left-0 w-[70%] max-w-[260px] z-50
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}
        >

          <h2 className="text-xl font-bold mb-6 flex items-center justify-center gap-2">
            <IoArrowBackOutline
              onClick={handleGoBack}
              className="text-lg cursor-pointer text-[#BE9524] hover:text-yellow-500 transition"
            />
            BLACKDEFYNITION
          </h2>

          <nav className='flex flex-col w-full gap-y-1'>
            {sections.map(section => (
              <div
                key={section.id}
                className="w-full"
                onClick={() => {
                  if (closeOnClick.includes(section.id)) {
                    setIsSidebarOpen(false);
                  }
                }}
                style={{
                  pointerEvents: settingsLoading === 'loading' ? 'none' : 'auto'
                }}
              >

                {section.subSections ? (
                  <>
                    {/* Parent Section */}
                    <div
                      onClick={() => toggleSection(section.id)}
                      className={`w-full p-3 cursor-pointer rounded flex items-center justify-between transition-colors duration-300 ${collapsedSections.includes(section.id)
                        ? "bg-customGray"
                        : "hover:bg-customGray"
                        }`}
                    >
                      <span className="flex items-center w-full">
                        {section.icon}
                        <span className="ml-2">{section.name}</span>
                      </span>
                      {collapsedSections.includes(section.id) ? (
                        <FaChevronRight />
                      ) : (
                        <FaChevronDown />
                      )}
                    </div>

                    {/* Subsections */}
                    {!collapsedSections.includes(section.id) && (
                      <div className="flex pl-5 gap-y-1 flex-col w-full">
                        {section.subSections.map((subSection) => (
                          <Link
                            onClick={() => setIsSidebarOpen(false)}

                            key={subSection.id}
                            to={`?tab=${subSection.id}`}
                            className={`w-full p-3 cursor-pointer rounded flex items-center transition-colors duration-300 ${activeSection === subSection.id
                              ? "bg-[#BE9524] text-black"
                              : "hover:bg-customGray"
                              }`}
                          >
                            {subSection.icon}
                            <span className="ml-2">{subSection.name}</span>
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  /* Single Section */
                  <Link
                    to={section.id === "general" ? "" : `?tab=${section.id}`}
                    className={`w-full p-3 cursor-pointer rounded flex items-center transition-colors duration-300 ${activeSection === section.id || (section.id === "general" && !activeSection)
                      ? "bg-[#BE9524] text-black"
                      : "hover:bg-customGray"
                      }`}
                  >
                    {section.icon}
                    <span className="ml-2">{section.name}</span>
                  </Link>
                )}
              </div>
            ))}
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-1 overflow-y-auto scrollbar-hide">
          {settingsLoading === 'loading' ? (
            <div className="flex justify-center items-center h-full min-h-[calc(100vh-120px)] bg-customGray rounded-lg">
              {/* Loading spinner */}
              <div className="flex flex-col items-center">
                <svg
                  className="animate-spin h-8 w-8 text-customGold"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <p className="mt-3 text-white text-sm font-medium">Loading content...</p>
              </div>
            </div>
          ) : (
            renderContent()
          )}
        </div>
      </div>

      {/* Hamburger Toggle Button */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="md:hidden fixed bottom-6 right-6 z-50 bg-[#BE9524] text-black p-3 rounded-full shadow-lg"
      >
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>
    </div>
  );

};

export default Settings;
